import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, Layout, Modal, Table } from '@vwfs-bronson/bronson-react';
import {
  customerSelectors,
  setShouldLinkSignatoryStakeholder,
  StakeholderContactDefinition,
} from '../../../../services/redux/features/customer.slice';

const SignatoriesTable = ({ signatoriesList, onSignatorySelect, selectedSignatory, onSignatoryDelete }) => {
  const { t } = useTranslation();

  const tableHeaders = [
    'number',
    'ceoLastName',
    'ceoFirstName',
    'ceoDateOfBirth',
    'zipCode',
    'ceoBirthPlaceCity',
    'email',
  ];
  const translatedHeaders = tableHeaders.reduce(
    (acc, curr) => ({ ...acc, [curr]: t(`step4:signatoryTable:headers:${curr}`, { defaultValue: '' }) }),
    {}
  );

  return (
    <Layout>
      <Layout.Item>
        <Table id="availableSignatoriesTable" wide>
          <Table.Thead>
            <Table.Tr>
              {tableHeaders.map((header: string) => (
                <Table.Th className="u-ws-nowrap" key={`signatory-header-${header}`}>
                  {translatedHeaders[header]}
                </Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {signatoriesList.map((row: any, index: number) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Tr key={`${row?.milesStakeholderContactId}-${index}`} className="u-ws-nowrap">
                {tableHeaders.map((header: string, index: number) =>
                  index === 0 ? (
                    <Table.Td key={`${header}.cell`} style={{ userSelect: 'text' }}>
                      <Checkbox
                        key={`${header}.cell`}
                        checked={selectedSignatory?.milesContactId === row.milesContactId}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => {
                          onSignatorySelect(row);
                        }}
                      />
                    </Table.Td>
                  ) : (
                    <Table.Td key={`${header}.cell`} style={{ userSelect: 'text' }}>
                      {row?.['formData'][header]}
                    </Table.Td>
                  )
                )}
                <Table.Td>
                  <Button
                    secondary
                    ariaLabel="delete signatory"
                    icon="semantic-delete"
                    onClick={() => onSignatoryDelete(row)}
                  />
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Layout.Item>
    </Layout>
  );
};

export const SignatorySelectionModal: React.FC<any> = ({
  onAbort,
  onConfirm,
  signatoriesList,
  shown,
  onSignatoryDelete,
}) => {
  const { t } = useTranslation();
  const [selectedSignatory, setSelectedSigntory] = useState<StakeholderContactDefinition | null>(null);
  const dispatch = useDispatch();

  const stakeholderContacts = useSelector(customerSelectors.selectStakeholderContacts);
  const signatoryData = useMemo(() => stakeholderContacts.SIGNATORY, [stakeholderContacts]);

  useEffect(() => {
    setSelectedSigntory(signatoryData || null);
    dispatch(setShouldLinkSignatoryStakeholder(true));
  }, [dispatch, signatoryData]);

  const handleAbort = () => {
    setSelectedSigntory(null);
    onAbort();
  };

  return (
    <Modal
      large
      center
      title={t(`step4:signatoryTable:modal:title`)}
      shown={shown}
      buttonConfirmLabel={t(`step4:stakeholderSection:buttons:remove`)}
      buttonCancelLabel={t(`step4:stakeholderSection:buttons:cancel`)}
      buttonCancelText={t(`step4:stakeholderSection:buttons:cancel`)}
      buttonConfirmText={t(`step4:stakeholderSection:buttons:apply`)}
      onCancel={handleAbort}
      onAbort={handleAbort}
      onClose={handleAbort}
      onConfirm={() => onConfirm(selectedSignatory)}
    >
      <SignatoriesTable
        signatoriesList={signatoriesList}
        onSignatorySelect={setSelectedSigntory}
        selectedSignatory={selectedSignatory}
        onSignatoryDelete={onSignatoryDelete}
      />
    </Modal>
  );
};
